import React,{useState,useEffect} from 'react';
import useStyles, { getMuiTheme } from "./styles";

import {FormControl,FormGroup, FormControlLabel,Switch ,CircularProgress,Avatar, Chip,Grid,Checkbox,Box,MenuItem,TextField, useTheme,Paper,Card,CardContent,Typography,CardActions,Button } from '@material-ui/core';
import { FormInput } from "../../";

import {NotificationsActive as NotificationsActiveIcon, Search as SearchIcon, Email as EmailIcon} from '@material-ui/icons';
import {pathOr,clone} from "ramda";
import {  useSelector } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core/styles";
export default function Reminders({ field, module, onChange, errors = {}, variant = "outlined", value, small = false, onBlur,disabled=false,view='',quickCreate=false  }) {
  let iserror = errors[field.name] ? true : false;
  console.log(field.value)
  console.log(module)
  // alert(view)
  // alert("VALUES")
  const {currentUserData} = useSelector((state) => state.config);
  const classes = useStyles();
  const theme = useTheme();
  const defaultReminderData = {"idx":0,"id":"","popup":true,"email":true,"timer_popup":"1800","timer_email":"3600","del_invitees":[],"invitees":[{id:"",module_id:pathOr("",["data","id"],currentUserData),module:"Users","value":pathOr("",["data","attributes","name"],currentUserData),"name":pathOr("",["data","attributes","name"],currentUserData),"email":pathOr("",["data","attributes","email1"],currentUserData)}]};
  const [remindersData,setRemindersData]= useState(field.value?field.value:[defaultReminderData]);
  
  const priorArr=[
    {label:'1 minute prior',value:60},
    {label:'5 minute prior',value:300},
    {label:'10 minute prior',value:600},
    {label:'15 minute prior',value:900},
    {label:'30 minute prior',value:1800},
    {label:'1 hour prior',value:3600},
    {label:'2 hour prior',value:7200},
    {label:'3 hour prior',value:10800},
    {label:'5 hour prior',value:18000},
    {label:'1 day prior',value:86400}
  ];

  const [IsVisible, setIsVisible] = useState(false)
  
  const renderOptions = () => {
    let optionsToRender = [];
    for (let optionKey in priorArr) {
      optionsToRender.push(
        <MenuItem key={optionKey} value={priorArr[optionKey].value}>
          <span>{priorArr[optionKey].label}</span>
        </MenuItem>
      );
    }
    return optionsToRender;
  };

  // Initializing didMount as false
// const [didMount, setDidMount] = useState(false)

// // Setting didMount to true upon mounting
//   useEffect(() => {
//     loadData()
//   },[didMount, remindersData])
//   const loadData = () => {
//     onChange(remindersData)
//   }

  const [cnt, setcnt] = useState(0)

  const addReminder =() =>{
    // setDidMount(true);
    // alert(cnt);
    if(cnt===0 && field.value){
      setRemindersData(remindersData.concat(defaultReminderData))
      let reminderDataArray = remindersData.concat(defaultReminderData);
      onChange(reminderDataArray);
      setIsVisible(true)
      setcnt(cnt+1)
    } else if (cnt===0) {
      onChange(remindersData);
      setIsVisible(true)
      setcnt(cnt+1)

    } else {
      setRemindersData(remindersData.concat(defaultReminderData));
      let reminderDataArray = remindersData.concat(defaultReminderData);
      onChange(reminderDataArray);
      setcnt(cnt+1)
      // setIsVisible(true)
    }
  }
  const removeReminder =(reminderKey) =>{
    let newData = clone(remindersData);
    //console.log("reminderKey",reminderKey);
    newData.splice(reminderKey,1);
    onChange(newData);
    setRemindersData(newData);
  }
  const handleSelectInvitees =(val,reminderKey)=>{
    console.log("val",val);
    console.log("remindersData before",remindersData);
    let newData = clone(remindersData);
    newData[reminderKey].invitees = newData[reminderKey].invitees.concat(val);
    setRemindersData(newData);
    onChange(newData);
    console.log("remindersData after",newData);
  }
  const handleDeleteInvitees =(reminderKey,inviteeKey)=>{
    if(remindersData[reminderKey].del_invitees == undefined){
      remindersData[reminderKey].del_invitees = [];
    }
    let selectedInviteesOld = clone(remindersData);    
    selectedInviteesOld[reminderKey].del_invitees = [...selectedInviteesOld[reminderKey].del_invitees,remindersData[reminderKey].invitees[inviteeKey]];
    selectedInviteesOld[reminderKey].invitees.splice(inviteeKey,1);
    onChange(selectedInviteesOld);
    setRemindersData(selectedInviteesOld);    
  }
  const handleToggle = (key,value) => () => {
    let data = clone(remindersData);
    data[key][value] = !data[key][value];
    onChange(data);
    setRemindersData(data);
  };
  const handleChange=(e,key)=>{
    let data = clone(remindersData);
    data[key][e.target.name] = e.target.value;
    console.log(data)
    setRemindersData(data);
    onChange(data);
  }


  return (
   <>
   
   {!disabled?<Typography className={classes.title} color="textSecondary" gutterBottom>Reminders:</Typography>:""}
    <Paper>
      
    <Card className={classes.root}>
      {field.value && view=="detailview" ||  view=="editview" && IsVisible || field.value && view=="editview"  ? 
      <CardContent>
        <MuiThemeProvider theme={getMuiTheme(theme)}>
        <Grid container spacing={3}>
          {
            remindersData.map((reminder,reminderKey)=>(
              <>
                <Grid item xs={12} sm={quickCreate?12:6}>                  
                  <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.card} style={{[(reminderKey+1)%2===0?'marginLeft':'marginRight']:quickCreate?0:20,width:'100%'}}>
                  <Box className={classes.inviteeNames}>
                    {
                      reminder.invitees.map((data,key)=>(
                        <>
                          {console.log("DATA",data)}
                          {console.log("REMINDER DATA",remindersData)}
                          {console.log("KEY",key)}
                          {/* <h1>Hello</h1> */}
                          <Chip color={view=='detailview'?"secondary":""} className={classes.invitee} disabled={disabled} label={data.value} variant="outlined" onDelete={()=>{handleDeleteInvitees(reminderKey,key)}} />
                        </>
                      ))
                    }
                  </Box>
                  <Box>
                    <Grid container>
                      {view!='detailview'?
                      <Grid item xs={12}>
                        <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                        
                          <Grid item   className={classes.addInviteeBtn}>
                            <FormInput 
                              field={{type:'relate',name:'invitees',module:'Users',label:"Add Invitees"}}
                              module={"Users"}
                              tooltipTitle="Add Invitees"
                              value={""}
                              multiSelect={true}
                              onChange={(val)=>handleSelectInvitees(val,reminderKey)}
                              component={"reminder"}
                              isIconBtn={true}
                              btnIcon={<><SearchIcon /> Users</>}
                              isSelectBtn={true}
                              color="primary"
                              variant="outlined"
                              disabled={disabled}
                              
                            />
                          </Grid>
                          <Grid item   className={classes.addInviteeBtn}>
                            <FormInput 
                              field={{type:'relate',name:'invitees',module:'Contacts',label:"Add Invitees"}}
                              module={"Contacts"}
                              tooltipTitle="Add Invitees"
                              value={""}
                              multiSelect={true}
                              onChange={(val)=>handleSelectInvitees(val,reminderKey)}
                              component={"reminder"}
                              isIconBtn={true}
                              btnIcon={<><SearchIcon /> Contacts</>}
                              isSelectBtn={true}
                              variant="outlined"
                              disabled={disabled}
                              color="primary"
                            />
                          </Grid>
                          <Grid item  className={classes.addInviteeBtn}>
                            <FormInput 
                              field={{type:'relate',name:'invitees',module:'Leads',label:"Add Invitees"}}
                              module={"Leads"}
                              tooltipTitle="Add Invitees"
                              value={""}
                              multiSelect={true}
                              onChange={(val)=>handleSelectInvitees(val,reminderKey)}
                              component={"reminder"}
                              isIconBtn={true}
                              btnIcon={<><SearchIcon /> Leads</>}
                              isSelectBtn={true}
                              variant="outlined"
                              
                              disabled={disabled}
                              color="primary"
                            />
                          </Grid>
                          </Grid>
                        
                      </Grid>:""}
                      <Grid item xs={12} className={classes.addInviteeBtn}>
                        <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                          <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                              <FormGroup aria-label="position" row>
                                <FormControlLabel
                                  value="start"
                                  control={<Switch
                                  edge="end"
                                  value={reminder.popup}
                                  onChange={handleToggle(reminderKey,'popup')}
                                  checked={reminder.popup}
                                  disabled={disabled}
                                  color={view=='detailview'?"secondary":"primary"}                            
                                />}
                                  label={" Popup"}
                                  labelPlacement="end"
                                  
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            {reminder.popup==true &&
                              <TextField
                                  id={`timer_popup${reminderKey}`}
                                  name={"timer_popup"}
                                  error={iserror}
                                  required={field.required === 'true' ? true : false}
                                  select
                                  label={field.label}
                                  value={reminder.timer_popup || "1800"}
                                  onChange={(e)=>handleChange(e,reminderKey)}
                                  variant={variant}              
                                  size={"small"}              
                                  //helperText={helperText !== "" ? helperText : errors[field.name] ? errors[field.name] : null}
                                  disabled={disabled}
                                  fullWidth={true}
                                  className={classes.select}
                                >
                                  {renderOptions()}
                              </TextField>
                            }
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className={classes.addInviteeBtn}>
                        <Grid container>
                          <Grid item xs={12} sm={6}>
                            <FormControl component="fieldset">
                              <FormGroup aria-label="position" row>
                                <FormControlLabel
                                  value="start"
                                  control={<Switch
                                  edge="end"
                                  value={reminder.email}
                                  onChange={handleToggle(reminderKey,'email')}
                                  checked={reminder.email}
                                  color={view=='detailview'?"secondary":"primary"}
                              />}
                                  label={" Email"}
                                  labelPlacement="end"
                                  disabled={disabled}
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            {reminder.email==true &&
                              <TextField
                                id={field.name}
                                name={"timer_email"}
                                error={iserror}
                                required={field.required === 'true' ? true : false}
                                select
                                label={field.label}
                                value={reminder.timer_email || "1800"}
                                onChange={(e)=>handleChange(e,reminderKey)}
                                variant={variant}              
                                size={"small"}              
                                //helperText={helperText !== "" ? helperText : errors[field.name] ? errors[field.name] : null}
                                disabled={disabled}
                                fullWidth={true}
                                className={classes.select}
                              >
                                {renderOptions()}
                              </TextField>
                            }
                          </Grid>
                        </Grid>
                      </Grid>                      
                      <Grid item xs={12}>                      
                        {!disabled?<Button disabled={reminderKey===0} variant="outlined" size="small" color="primary" onClick={()=>removeReminder(reminderKey)} className={classes.margin}>Remove Reminder</Button>:''}
                      </Grid>
                    </Grid>
                  </Box>
                  <Box>
                    
                  </Box>
                  </Grid>
                  </Grid>
                </Grid>          
              
              </>
            ))
          }
          </Grid>
          </MuiThemeProvider>
      </CardContent> : ""}
      <CardActions>
        {!disabled?<Button variant="contained" size="small" color="primary" onClick={addReminder} className={classes.margin}>Add Reminder</Button>:""}
      </CardActions>
    </Card>
    
    </Paper>
    
   </>
  );
}
